import { ReactNode } from 'react';
import { ToneCountWithUser } from '@/utils/helpers';
import { ToneCardRow } from './ToneCardRow';

interface Props {
  title: string;
  tones: ToneCountWithUser[];
  gridLimit?: number;
  /** CTA beside the title, hidden below sm. */
  action?: ReactNode;
  /** CTA under the row, bring your own wrapper for width and breakpoints. */
  footer?: ReactNode;
  /** Homepage rows run larger than sections nested inside a page. */
  titleClassName?: string;
}

// Owns the header/row/footer stack only. The page gutter belongs to the
// caller, since the same section sits in a homepage container on one surface
// and inside an existing page container on another.
export const ToneSection = ({
  title,
  tones,
  gridLimit,
  action,
  footer,
  titleClassName = 'text-2xl font-bold',
}: Props) => (
  <div className="flex flex-col gap-8">
    <div className="flex flex-row gap-8 items-center justify-between">
      <h2 className={`${titleClassName} text-white truncate`}>{title}</h2>
      {!!action && <div className="hidden sm:block">{action}</div>}
    </div>
    <ToneCardRow tones={tones} gridLimit={gridLimit} />
    {footer}
  </div>
);
